/* global analytics */

export const OPENED_MENU = 'Clicked burger menu button';
export const CLICKED_DECLINED_BUTTON = 'Clicked on the decline button';
export const DECLINED_OPPORTUNITY = 'Declined an opportunity';
export const CLICKED_INVEST_BUTTON = 'Clicked on the co-invest button';
export const SUBMITTED_WISH_AMOUNT = 'Submitted a wish amount';
export const VALIDATED_WISH_AMOUNT = 'Validated a wish amount';
export const ACKNOWLEDGED_WISH_CONFIRMATION = 'Clicked the back to dashboard button';
export const CLICKED_ACCEPT_BUTTON = 'Clicked on the accept button';
export const OPENED_ADMIN_DOCUMENT = 'Opened Admin Document';
export const ASK_FOR_PASSWORD = 'Asked for a new password';
export const SUBMIT_NEW_PASSWORD = 'Submitted a new password';
export const OPENED_CONVENTION = 'Opened convention';
export const OPENED_LETTER_OF_MISSION = 'Opened Letter of mission';

export default {
  identify({ id, name, email }) {
    analytics.identify(id, { name, email });
  },
};
